import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useCart } from '../context/CartContext'
import './Header.css'

function Header({ title, showBack = false, showCart = true, showProfile = true }) {
  const navigate = useNavigate()
  const { getCartItemsCount, hapticFeedback } = useCart()

  const handleBack = () => {
    hapticFeedback('light')
    navigate(-1)
  }

  const handleCartClick = () => {
    hapticFeedback('medium')
    navigate('/cart')
  }

  const handleProfileClick = () => {
    hapticFeedback('medium')
    navigate('/profile')
  }

  const handleHomeClick = () => {
    hapticFeedback('light')
    navigate('/')
  }

  return (
    <header className="app-header">
      <div className="header-left">
        {showBack ? (
          <button className="header-btn back-btn" onClick={handleBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        ) : (
          <div className="header-brand" onClick={handleHomeClick}>
            <h1 className="brand-title">meta wer shop</h1>
            <p className="brand-subtitle">магазин одежды</p>
          </div>
        )}
        {showBack && title && (
          <h2 className="header-title">{title}</h2>
        )}
      </div>
      <div className="header-actions">
        {showProfile && (
          <button className="header-btn profile-btn" onClick={handleProfileClick}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/>
              <path d="M4 20C4 16.6863 6.68629 14 10 14H14C17.3137 14 20 16.6863 20 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        )}
        {showCart && (
          <button className="header-btn cart-btn" onClick={handleCartClick}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 2L7 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M15 2L17 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M1 6H23L21 20H3L1 6Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
            </svg>
            {getCartItemsCount() > 0 && (
              <span className="header-badge">{getCartItemsCount()}</span>
            )}
          </button>
        )}
      </div>
    </header>
  )
}

export default Header











